import MkuBreadcrumb from './src/breadcrumb';

MkuBreadcrumb.install = function (Vue) {
  Vue.component(MkuBreadcrumb.name, MkuBreadcrumb);
};

export default MkuBreadcrumb;
